/**
 * 品牌規範 UI 總開關(R397;R213 起的 gate 常數慣例)。
 * -----------------------------------------------------------------------------
 * 🔴 **owner 2026-10-07 拍板隱藏**:「品牌規範的所有東西,頁面先進行隱藏,品牌規範+
 * 建立專案的品牌規範選擇都需要隱藏。然後備注文字直到我們授權打開,先進行注記。」
 * —— **直到 owner 授權才翻 `true`**;翻開即全部回來,零散改。
 *
 * 蓋住的入口(全部走本常數,勿各自再開 gate):
 *   - 側欄「品牌規範」nav 項(AppSidebar)+ `/brand-kits*` route(redirect /projects)
 *   - 建立專案 / 編輯專案的「要引用哪一份品牌規範?」欄(Create/EditDialog)
 *   - 專案卡的品牌 chip(含「未引用品牌規範」;ProjectListItems)與列表頁的 kits 抓取
 *   - 首頁的品牌規範側欄區塊(kits 抓取改回空,區塊自然不顯)
 *   - 右側面板「品牌規範」區塊(ToolInspector:toggle 與「前往品牌規範頁」連結)
 *   - 生成確認框的「本次不套用品牌規範」勾選(GenerateConfirmDialog)
 *
 * ⚠️ **只藏 UI,不動機制**:wire 能力(`PROJECT_BRAND_KIT_PATCH_SUPPORTED`)、submit 帶
 * `brandKitId`、BE 對已綁定專案的套用行為全部照舊 —— 存量綁了品牌規範的專案,生成仍會
 * 套用,只是畫面上不再有品牌規範的入口與說明。翻開本常數前**不要**為了「看起來乾淨」
 * 去清存量綁定。
 *
 * 測試慣例:行為測試(下拉 / chip)以 `vi.mock` 蓋本檔 `true` 保留(翻開當天即生效、
 * 守門不腐);另有「預設 false → 入口不渲染」的鎖,翻開時那幾條會紅 —— 把它們反轉即可。
 */
export const BRAND_KITS_UI_VISIBLE = false;
